import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HelpButton: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    navigate('/help-center');
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20, // WhatsApp butonunun altında
        right: 20,
        zIndex: 1000,
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <Paper
        elevation={6}
        sx={{
          px: 3,
          py: 2,
          borderRadius: 3,
          background: 'var(--cobalt-blue)',
          color: 'white',
          fontWeight: 600,
          fontSize: '1rem',
          boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
          display: 'flex',
          alignItems: 'center',
          minWidth: 200,
          transition: 'transform 0.2s',
          '&:hover': {
            background: 'var(--navy-blue)',
            transform: 'scale(1.04)',
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: 600, width: '100%', textAlign: 'center' }}>
          {t('common.needHelp', 'Yardıma mı ihtiyacınız var?')}
        </Typography>
      </Paper>
    </Box>
  );
};

export default HelpButton; 